import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiReferensiHutangService = new CrudCustom('/transaksi-referensi-hutangs');
export default TransaksiReferensiHutangService;
